
import React, { InputHTMLAttributes, ReactNode } from 'react';
import { UseFormRegisterReturn, UseFormGetValues, UseFormWatch } from 'react-hook-form';
import { useUtils } from "../../hooks/useUtils";
import InformationTag from '../InfoTag/InfoTag';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    itemNumber?: number;
    register: UseFormRegisterReturn;
    getItemizedFieldValue: UseFormGetValues<any>;
    watchItemizedFieldValue: UseFormWatch<any>;
    labelName?: ReactNode;
    infoTagMessage?: string | " ";
    fieldName: string | "field";
    errors?: Record<string, any>; // Form state errors
}

const ReadOnlyInputField: React.FC<InputProps> = ({ register, labelName, fieldName, errors, itemNumber, infoTagMessage, getItemizedFieldValue, watchItemizedFieldValue, ...rest }) => {

    const helperUtils = useUtils();
    const fieldValue = watchItemizedFieldValue(register.name);

    return (
        <div className="mb-8">
            <div className="flex">
                <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                <div className="text-sm grid grid-cols-2"><div>{labelName}</div> <div className="ml-2"><InformationTag message={infoTagMessage} /></div></div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow mt-3 relative">
                    <div className="absolute top-2 left-2 z-10 w-auto min-w-80 bg-gray-50 dark:bg-gray-700 pr-20">{helperUtils.convertToMoney(fieldValue)}</div>
                    <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        {...rest}
                        {...register} // This spreads the register function correctly
                    />
                    {errors && errors[fieldName] && (
                        <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReadOnlyInputField;